webpackJsonp([35783957827783],{

/***/ 89:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.bcf576a1.png";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ocelli-alpha.4d6cf2f1.png";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ocelli-bravo.c4bf563c.png";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ocelli-charlie.cb6cf190.png";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ocelli-default.f6f3a9b3.png";

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var lang = '_nl';
	
	exports.lang = lang;

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(86);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cover = __webpack_require__(428);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _ocelliDefault = __webpack_require__(433);
	
	var _ocelliDefault2 = _interopRequireDefault(_ocelliDefault);
	
	var _ocelliAlpha = __webpack_require__(430);
	
	var _ocelliAlpha2 = _interopRequireDefault(_ocelliAlpha);
	
	var _ocelliBravo = __webpack_require__(431);
	
	var _ocelliBravo2 = _interopRequireDefault(_ocelliBravo);
	
	var _ocelliCharlie = __webpack_require__(432);
	
	var _ocelliCharlie2 = _interopRequireDefault(_ocelliCharlie);
	
	__webpack_require__(324);
	
	var _language = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  var arrayChangelog = data.allTranslationsXlsxChangelog.edges;
	  var arrayFeatures = data.allTranslationsXlsxFeatures.edges;
	  var arrayHomepageContent = data.allTranslationsXlsxHomepage.edges;
	  var introduction = void 0,
	      features = void 0,
	      presets = void 0,
	      support = void 0,
	      changelog = void 0;
	
	  arrayHomepageContent.forEach(function (item) {
	    item.node.key == 'introduction' ? introduction = item.node : null;
	    item.node.key == 'features' ? features = item.node : null;
	    item.node.key == 'presets' ? presets = item.node : null;
	    item.node.key == 'support' ? support = item.node : null;
	    item.node.key == 'changelog' ? changelog = item.node : null;
	  });
	
	  var support_content = support['content' + _language.lang].replace(/support@brotherspeacock.com/ig, function replace(match) {
	    return '<a class="link" href="mailto:' + match + '">' + match + '</a>';
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 's-homepage' },
	    _react2.default.createElement(
	      'header',
	      { className: 'section-header' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'section-title' },
	        introduction['heading' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'section-description' },
	        introduction['content' + _language.lang]
	      ),
	      _react2.default.createElement('img', { className: 'section-image', src: _cover2.default })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'homepage-section' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'section-title' },
	        features['heading' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'features-container' },
	        arrayFeatures.map(function (_ref2, index) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            'li',
	            { className: 'feature', key: index },
	            _react2.default.createElement(
	              'span',
	              { className: 'feature-icon' },
	              _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                'star_border'
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'feature-title' },
	              node['feature' + _language.lang]
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'homepage-section' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'section-title' },
	        presets['heading' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'section-description' },
	        presets['content' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'presets-container' },
	        _react2.default.createElement(
	          'li',
	          { className: 'preset' },
	          _react2.default.createElement(
	            'a',
	            { className: 'preset-link', target: '_blank', href: 'http://ocelliocellus-theme.webshopapp.com' },
	            _react2.default.createElement('img', { src: _ocelliDefault2.default, width: '250', height: '250', alt: 'Ocelli Ocellus Default' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'preset-title' },
	              'Ocelli Ocellus'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'preset' },
	          _react2.default.createElement(
	            'a',
	            { className: 'preset-link', target: '_blank', href: 'http://ocelliocellus-preset-1-theme.webshopapp.com' },
	            _react2.default.createElement('img', { src: _ocelliAlpha2.default, width: '250', height: '250', alt: 'Ocelli Ocellus Default' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'preset-title' },
	              'Ocelli Alpha'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'preset' },
	          _react2.default.createElement(
	            'a',
	            { className: 'preset-link', target: '_blank', href: 'http://ocelliocellus-preset-2-theme.webshopapp.com' },
	            _react2.default.createElement('img', { src: _ocelliBravo2.default, width: '250', height: '250', alt: 'Ocelli Ocellus Default' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'preset-title' },
	              'Ocelli Bravo'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'preset' },
	          _react2.default.createElement(
	            'a',
	            { className: 'preset-link', target: '_blank', href: 'http://ocelliocellus-preset-3-theme.webshopapp.com' },
	            _react2.default.createElement('img', { src: _ocelliCharlie2.default, width: '250', height: '250', alt: 'Ocelli Ocellus Default' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'preset-title' },
	              'Ocelli Charlie'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'homepage-section' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'section-title' },
	        support['heading' + _language.lang]
	      ),
	      _react2.default.createElement('p', { className: 'section-description', dangerouslySetInnerHTML: { __html: support_content } })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'homepage-section' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'section-title' },
	        changelog['heading' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'changelog-container' },
	        arrayChangelog.map(function (_ref3, index) {
	          var node = _ref3.node;
	          return _react2.default.createElement(
	            'li',
	            { className: 'changelog-item', key: index },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'changelog-date-icon' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'material-icons' },
	                  'insert_invitation'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'changelog-date' },
	                node.date,
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'changelog-version' },
	                  ' - ',
	                  node.version
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'change-log-title' },
	              node['content' + _language.lang]
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-204aa528cd5a47965a88.js